import ContactInformationTemplate from "YConnect/Configs/Templates/ContactInformation.template.json"

export default {
    "template": ContactInformationTemplate
}